const Icons = {
  ic_naira: require("./ic_naira.svg").default,
  ic_like: require("./ic_like.svg").default,
  ic_chart: require("./ic_chart.svg").default,
  ic_points: require("./ic_points.svg").default,
  ic_points_thumb: require("./ic_points_thumb.svg").default,
  ic_linkedin_green: require("./ic_linkedin_green.svg").default,
  ic_right: require("./ic_right.svg").default,
  ic_down: (
    <svg
      width="13"
      height="7"
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.377727 1.31913L5.58748 6.22243C6.10088 6.70563 6.90172 6.70563 7.41512 6.22243L12.6249 1.31913C12.893 1.06678 12.9058 0.644868 12.6534 0.376752C12.4011 0.108636 11.9792 0.0958509 11.7111 0.348195L6.5013 5.2515L1.29155 0.348194C1.02343 0.09585 0.601515 0.108635 0.349171 0.376751C0.0968263 0.644867 0.109612 1.06678 0.377727 1.31913Z"
        fill="currentColor"
      />
    </svg>
  ),
  ic_accordion: require("./ic_accordion.svg").default,
  ic_empty_state: require("./ic_empty_state.svg").default,
  ic_search: require("./ic_search.svg").default,
  ic_back_nav: require("./ic_back_nav.svg").default,
  ic_download: require("./ic_download.svg").default,
  ic_next: require("./ic_next.svg").default,

  ic_step1: require("./ic_step1.svg").default,
  ic_step2: require("./ic_step2.svg").default,
  ic_step3: require("./ic_step3.svg").default,
  ic_step4: require("./ic_step4.svg").default,
  ic_step5: require("./ic_step5.svg").default,
  ic_step6: require("./ic_step6.svg").default,
  ic_step7: require("./ic_step7.svg").default,

  ic_facebook: (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 16C0.5 24.8366 7.66344 32 16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16Z"
        fill="#0F973D"
      />
      <path
        d="M24.5 16C24.5 11.6 20.9 8 16.5 8C12.1 8 8.5 11.6 8.5 16C8.5 20 11.4 23.3 15.2 23.9V18.3H13.2V16H15.2V14.2C15.2 12.2 16.4 11.1 18.2 11.1C19.1 11.1 20 11.3 20 11.3V13.3H19C18 13.3 17.7 13.9 17.7 14.5V16H19.9L19.5 18.3H17.6V24C21.6 23.4 24.5 20 24.5 16Z"
        fill="white"
      />
    </svg>
  ),
  ic_instagram: (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 16C0.5 24.8366 7.66344 32 16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16Z"
        fill="#0F973D"
      />
      <path
        d="M16.5002 9.2002C18.7002 9.2002 19.0002 9.2002 19.9002 9.2002C20.7002 9.2002 21.1002 9.4002 21.4002 9.5002C21.8002 9.7002 22.1002 9.8002 22.4002 10.1002C22.7002 10.4002 22.9002 10.7002 23.0002 11.1002C23.1002 11.4002 23.2002 11.8002 23.3002 12.6002C23.3002 13.5002 23.3002 13.7002 23.3002 16.0002C23.3002 18.3002 23.3002 18.5002 23.3002 19.4002C23.3002 20.2002 23.1002 20.6002 23.0002 20.9002C22.8002 21.3002 22.7002 21.6002 22.4002 21.9002C22.1002 22.2002 21.8002 22.4002 21.4002 22.5002C21.1002 22.6002 20.7002 22.7002 19.9002 22.8002C19.0002 22.8002 18.8002 22.8002 16.5002 22.8002C14.2002 22.8002 14.0002 22.8002 13.1002 22.8002C12.3002 22.8002 11.9002 22.6002 11.6002 22.5002C11.2002 22.3002 10.9002 22.2002 10.6002 21.9002C10.3002 21.6002 10.1002 21.3002 10.0002 20.9002C9.9002 20.6002 9.8002 20.2002 9.7002 19.4002C9.7002 18.5002 9.7002 18.3002 9.7002 16.0002C9.7002 13.7002 9.7002 13.5002 9.7002 12.6002C9.7002 11.8002 9.9002 11.4002 10.0002 11.1002C10.2002 10.7002 10.3002 10.4002 10.6002 10.1002C10.9002 9.8002 11.2002 9.6002 11.6002 9.5002C11.9002 9.4002 12.3002 9.3002 13.1002 9.2002C14.0002 9.2002 14.3002 9.2002 16.5002 9.2002ZM16.5002 7.7002C14.2002 7.7002 14.0002 7.7002 13.1002 7.7002C12.2002 7.7002 11.6002 7.9002 11.1002 8.1002C10.6002 8.3002 10.1002 8.6002 9.6002 9.1002C9.1002 9.6002 8.9002 10.0002 8.6002 10.6002C8.4002 11.1002 8.3002 11.7002 8.2002 12.6002C8.2002 13.5002 8.2002 13.8002 8.2002 16.0002C8.2002 18.3002 8.2002 18.5002 8.2002 19.4002C8.2002 20.3002 8.4002 20.9002 8.6002 21.4002C8.8002 21.9002 9.1002 22.4002 9.6002 22.9002C10.1002 23.4002 10.5002 23.6002 11.1002 23.9002C11.6002 24.1002 12.2002 24.2002 13.1002 24.3002C14.0002 24.3002 14.3002 24.3002 16.5002 24.3002C18.7002 24.3002 19.0002 24.3002 19.9002 24.3002C20.8002 24.3002 21.4002 24.1002 21.9002 23.9002C22.4002 23.7002 22.9002 23.4002 23.4002 22.9002C23.9002 22.4002 24.1002 22.0002 24.4002 21.4002C24.6002 20.9002 24.7002 20.3002 24.8002 19.4002C24.8002 18.5002 24.8002 18.2002 24.8002 16.0002C24.8002 13.8002 24.8002 13.5002 24.8002 12.6002C24.8002 11.7002 24.6002 11.1002 24.4002 10.6002C24.2002 10.1002 23.9002 9.6002 23.4002 9.1002C22.9002 8.6002 22.5002 8.4002 21.9002 8.1002C21.4002 7.9002 20.8002 7.8002 19.9002 7.7002C19.0002 7.7002 18.8002 7.7002 16.5002 7.7002Z"
        fill="white"
      />
      <path
        d="M16.5002 11.7002C14.1002 11.7002 12.2002 13.6002 12.2002 16.0002C12.2002 18.4002 14.1002 20.3002 16.5002 20.3002C18.9002 20.3002 20.8002 18.4002 20.8002 16.0002C20.8002 13.6002 18.9002 11.7002 16.5002 11.7002ZM16.5002 18.8002C15.0002 18.8002 13.7002 17.6002 13.7002 16.0002C13.7002 14.5002 14.9002 13.2002 16.5002 13.2002C18.0002 13.2002 19.3002 14.4002 19.3002 16.0002C19.3002 17.5002 18.0002 18.8002 16.5002 18.8002Z"
        fill="white"
      />
      <path
        d="M20.9002 12.6002C21.4525 12.6002 21.9002 12.1525 21.9002 11.6002C21.9002 11.0479 21.4525 10.6002 20.9002 10.6002C20.3479 10.6002 19.9002 11.0479 19.9002 11.6002C19.9002 12.1525 20.3479 12.6002 20.9002 12.6002Z"
        fill="white"
      />
    </svg>
  ),
  ic_linkedin: (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 16C0.5 24.8366 7.66344 32 16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16Z"
        fill="#0F973D"
      />
      <path
        d="M12.1 24H8.7V13.3H12.1V24ZM10.4 11.8C9.3 11.8 8.5 11 8.5 9.9C8.5 8.8 9.4 8 10.4 8C11.5 8 12.3 8.8 12.3 9.9C12.3 11 11.5 11.8 10.4 11.8ZM24.5 24H21.1V18.2C21.1 16.5 20.4 16 19.4 16C18.4 16 17.4 16.8 17.4 18.3V24H14V13.3H17.2V14.8C17.5 14.1 18.7 13 20.4 13C22.3 13 24.3 14.1 24.3 17.4V24H24.5Z"
        fill="white"
      />
    </svg>
  ),
  ic_twitter: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6 0.75H15.054L9.694 6.892L16 15.25H11.063L7.196 10.18L2.771 15.25H0.316L6.049 8.68L0 0.75H5.063L8.558 5.383L12.6 0.75ZM11.74 13.778H13.1L4.323 2.145H2.865L11.74 13.778Z"
        fill="white"
      />
    </svg>
  ),
  ic_user: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0002 2.16666C7.69898 2.16666 5.8335 4.03214 5.8335 6.33332C5.8335 8.63451 7.69898 10.5 10.0002 10.5C12.3013 10.5 14.1668 8.63451 14.1668 6.33332C14.1668 4.03214 12.3013 2.16666 10.0002 2.16666ZM7.50016 6.33332C7.50016 4.95261 8.61945 3.83332 10.0002 3.83332C11.3809 3.83332 12.5002 4.95261 12.5002 6.33332C12.5002 7.71404 11.3809 8.83332 10.0002 8.83332C8.61945 8.83332 7.50016 7.71404 7.50016 6.33332Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0002 19.6667C8.71641 19.6667 6.85834 19.3752 5.46302 18.7645C4.77802 18.4647 4.08137 18.0356 3.67662 17.4145C3.46376 17.0878 3.32919 16.7031 3.3336 16.2735C3.33797 15.8479 3.47803 15.4401 3.71343 15.0607C4.85459 13.2213 7.18915 11.3333 10.0002 11.3333C12.8112 11.3333 15.1457 13.2213 16.2869 15.0607C16.5223 15.4401 16.6624 15.8479 16.6667 16.2735C16.6711 16.7031 16.5366 17.0878 16.3237 17.4145C15.919 18.0356 15.2223 18.4647 14.5373 18.7645C13.142 19.3752 11.2839 19.6667 10.0002 19.6667ZM5.12966 15.9393C5.01993 16.1162 5.0008 16.2298 5.00018 16.2906C4.9996 16.3475 5.01422 16.4144 5.07297 16.5045C5.21145 16.717 5.54772 16.9822 6.13127 17.2376C7.27303 17.7374 8.89453 18 10.0002 18C11.1058 18 12.7273 17.7374 13.8691 17.2376C14.4526 16.9822 14.7889 16.717 14.9274 16.5045C14.9861 16.4144 15.0007 16.3475 15.0001 16.2906C14.9995 16.2298 14.9804 16.1162 14.8707 15.9393C13.9355 14.4321 12.0704 13 10.0002 13C7.92988 13 6.06478 14.4321 5.12966 15.9393Z"
        fill="currentColor"
      />
    </svg>
  ),
  ic_email: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8337 18C17.6747 18 19.167 16.5076 19.167 14.6667V7.18557C19.1673 7.17283 19.1673 7.16005 19.167 7.14725V6.33333C19.167 4.49238 17.6747 3 15.8337 3H4.16705C2.3261 3 0.833718 4.49238 0.833718 6.33333V7.14726C0.833422 7.16005 0.833423 7.17282 0.833718 7.18556V14.6667C0.833718 16.5076 2.3261 18 4.16705 18H15.8337ZM2.50038 14.6667C2.50038 15.5871 3.24658 16.3333 4.16705 16.3333H15.8337C16.7542 16.3333 17.5004 15.5871 17.5004 14.6667V8.39753L11.2384 10.9023C10.4436 11.2202 9.55712 11.2202 8.76241 10.9023L2.50038 8.39753V14.6667ZM10.6194 9.35488L17.5004 6.60247V6.33333C17.5004 5.41286 16.7542 4.66667 15.8337 4.66667H4.16705C3.24658 4.66667 2.50038 5.41286 2.50038 6.33333V6.60247L9.3814 9.35488C9.77875 9.51382 10.222 9.51382 10.6194 9.35488Z"
        fill="currentColor"
      />
    </svg>
  ),
  ic_phone: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.22854 2.83965C6.92679 1.5379 4.81625 1.53791 3.5145 2.83965L3.06822 3.28593C2.45291 3.90124 2.03206 4.8233 2.27211 5.82213C2.64012 7.35339 3.74753 10.1438 7.05003 13.4463C10.3525 16.7488 13.1429 17.8562 14.6742 18.2242C15.673 18.4642 16.5951 18.0434 17.2104 17.4281L17.6566 16.9818C18.9584 15.68 18.9584 13.5695 17.6566 12.2677L16.8826 11.4937C15.8215 10.4326 14.1823 10.2113 12.8779 10.9531L12.7974 10.9988C12.2629 11.3028 11.6488 11.2779 11.2138 10.9631C10.8628 10.709 10.5273 10.4417 10.2909 10.2053C10.0546 9.969 9.78724 9.63351 9.53321 9.28248C9.21837 8.84746 9.19353 8.23339 9.49748 7.69886L9.54322 7.61841C10.2849 6.314 10.0637 4.67477 9.00261 3.61372L8.22854 2.83965ZM4.69301 4.01817C5.34388 3.36729 6.39916 3.36729 7.05003 4.01816L7.8241 4.79223C8.35462 5.32275 8.46527 6.14237 8.0944 6.79458L8.04866 6.87502C7.46124 7.90807 7.44063 9.2338 8.18303 10.2596C8.45572 10.6364 8.78343 11.0549 9.11243 11.3839C9.44142 11.7129 9.85987 12.0406 10.2367 12.3133C11.2625 13.0557 12.5882 13.035 13.6213 12.4476L13.7017 12.4019C14.3539 12.031 15.1735 12.1417 15.7041 12.6722L16.4781 13.4463C17.129 14.0971 17.129 15.1524 16.4781 15.8033L16.0318 16.2496C15.7095 16.5719 15.3542 16.6735 15.0636 16.6037C13.8394 16.3094 11.3199 15.3591 8.22854 12.2677C5.13715 9.17635 4.18685 6.65687 3.89263 5.43267C3.82281 5.14213 3.92436 4.78682 4.24673 4.46444L4.69301 4.01817Z"
        fill="currentColor"
      />
    </svg>
  ),
  ic_company: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.91683 6.33333C7.91683 6.79357 7.54373 7.16667 7.0835 7.16667H6.25016C5.78993 7.16667 5.41683 6.79357 5.41683 6.33333C5.41683 5.8731 5.78993 5.5 6.25016 5.5H7.0835C7.54373 5.5 7.91683 5.8731 7.91683 6.33333Z"
        fill="currentColor"
      />
      <path
        d="M10.4168 9.66667C10.8771 9.66667 11.2502 9.29357 11.2502 8.83333C11.2502 8.3731 10.8771 8 10.4168 8H9.5835C9.12326 8 8.75016 8.3731 8.75016 8.83333C8.75016 9.29357 9.12326 9.66667 9.5835 9.66667H10.4168Z"
        fill="currentColor"
      />
      <path
        d="M7.91683 11.3333C7.91683 11.7936 7.54373 12.1667 7.0835 12.1667H6.25016C5.78993 12.1667 5.41683 11.7936 5.41683 11.3333C5.41683 10.8731 5.78993 10.5 6.25016 10.5H7.0835C7.54373 10.5 7.91683 10.8731 7.91683 11.3333Z"
        fill="currentColor"
      />
      <path
        d="M10.4168 7.16667C10.8771 7.16667 11.2502 6.79357 11.2502 6.33333C11.2502 5.8731 10.8771 5.5 10.4168 5.5H9.5835C9.12326 5.5 8.75016 5.8731 8.75016 6.33333C8.75016 6.79357 9.12326 7.16667 9.5835 7.16667H10.4168Z"
        fill="currentColor"
      />
      <path
        d="M7.91683 8.83333C7.91683 9.29357 7.54373 9.66667 7.0835 9.66667H6.25016C5.78993 9.66667 5.41683 9.29357 5.41683 8.83333C5.41683 8.3731 5.78993 8 6.25016 8H7.0835C7.54373 8 7.91683 8.3731 7.91683 8.83333Z"
        fill="currentColor"
      />
      <path
        d="M10.4168 12.1667C10.8771 12.1667 11.2502 11.7936 11.2502 11.3333C11.2502 10.8731 10.8771 10.5 10.4168 10.5H9.5835C9.12326 10.5 8.75016 10.8731 8.75016 11.3333C8.75016 11.7936 9.12326 12.1667 9.5835 12.1667H10.4168Z"
        fill="currentColor"
      />
      <path
        d="M7.91683 13.8333C7.91683 14.2936 7.54373 14.6667 7.0835 14.6667H6.25016C5.78993 14.6667 5.41683 14.2936 5.41683 13.8333C5.41683 13.3731 5.78993 13 6.25016 13H7.0835C7.54373 13 7.91683 13.3731 7.91683 13.8333Z"
        fill="currentColor"
      />
      <path
        d="M10.4168 14.6667C10.8771 14.6667 11.2502 14.2936 11.2502 13.8333C11.2502 13.3731 10.8771 13 10.4168 13H9.5835C9.12326 13 8.75016 13.3731 8.75016 13.8333C8.75016 14.2936 9.12326 14.6667 9.5835 14.6667H10.4168Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3335 4.66667C3.3335 3.74619 4.07969 3 5.00016 3H11.6668C12.5873 3 13.3335 3.74619 13.3335 4.66667V8H15.8335C16.754 8 17.5002 8.74619 17.5002 9.66667V16.3333H18.3335C18.7937 16.3333 19.1668 16.7064 19.1668 17.1667C19.1668 17.6269 18.7937 18 18.3335 18H1.66683C1.20659 18 0.833496 17.6269 0.833496 17.1667C0.833496 16.7064 1.20659 16.3333 1.66683 16.3333H3.3335V4.66667ZM5.00016 16.3333H11.6668V4.66667H5.00016V16.3333ZM15.8335 13V12.1667H15.4168C14.9566 12.1667 14.5835 11.7936 14.5835 11.3333C14.5835 10.8731 14.9566 10.5 15.4168 10.5H15.8335V9.66667H13.3335V16.3333H15.8335V14.6667H15.4168C14.9566 14.6667 14.5835 14.2936 14.5835 13.8333C14.5835 13.3731 14.9566 13 15.4168 13H15.8335Z"
        fill="currentColor"
      />
    </svg>
  ),
  ic_close: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.05086 18.3638C6.66033 18.7544 6.02717 18.7544 5.63664 18.3638C5.24612 17.9733 5.24612 17.3402 5.63664 16.9496L10.5864 11.9999L5.63664 7.05014C5.24612 6.65961 5.24612 6.02645 5.63664 5.63592C6.02717 5.2454 6.66033 5.2454 7.05086 5.63592L12.0006 10.5857L16.9504 5.63592C17.3409 5.2454 17.974 5.2454 18.3646 5.63592C18.7551 6.02645 18.7551 6.65961 18.3646 7.05014L13.4148 11.9999L18.3646 16.9496C18.7551 17.3402 18.7551 17.9733 18.3646 18.3638C17.974 18.7544 17.3409 18.7544 16.9504 18.3638L12.0006 13.4141L7.05086 18.3638Z"
        fill="currentColor"
      />
    </svg>
  ),
  ic_new_tab: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5893 3.86328C10.1291 3.86328 9.75596 4.23638 9.75596 4.69661C9.75596 5.15685 10.1291 5.52995 10.5893 5.52995H13.2915L4.10748 14.714C3.78204 15.0394 3.78204 15.567 4.10748 15.8925C4.43292 16.2179 4.96056 16.2179 5.28599 15.8925L14.47 6.70846V9.41066C14.47 9.8709 14.8431 10.244 15.3033 10.244C15.7636 10.244 16.1367 9.8709 16.1367 9.41066V4.69661C16.1367 4.23638 15.7636 3.86328 15.3033 3.86328H10.5893Z"
        fill="#98A2B3"
      />
    </svg>
  ),
  ic_menu: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.26758 4.5H21.2676"
        stroke="#0F973D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.26758 12.5H21.2676"
        stroke="#0F973D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.26758 20.5H21.2676"
        stroke="#0F973D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ic_arrow_up: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="currentColor"
      viewBox="0 0 256 256"
    >
      <path d="M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z"></path>
    </svg>
  ),
  ic_success: (
    <svg
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 31.125C24.7487 31.125 30.625 25.2487 30.625 18C30.625 10.7513 24.7487 4.875 17.5 4.875C10.2513 4.875 4.375 10.7513 4.375 18C4.375 25.2487 10.2513 31.125 17.5 31.125ZM22.86 16.1588C23.4539 15.6148 23.4944 14.6923 22.9505 14.0984C22.4065 13.5044 21.484 13.4639 20.89 14.0079L15.5058 18.9391L14.11 17.6608C13.516 17.1168 12.5935 17.1573 12.0496 17.7513C11.5056 18.3452 11.5461 19.2677 12.14 19.8117L14.5208 21.9921C15.0782 22.5026 15.9333 22.5026 16.4907 21.9921L22.86 16.1588Z"
        fill="#0F973D"
      />
    </svg>
  ),
  ic_loading: (
    <svg
      className="animate-spin h-8 w-8"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  ),

  ic_vision: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.18301 7.79827C5.66409 7.95863 6.04159 8.33614 6.20195 8.81722C6.36516 9.30683 7.0577 9.30683 7.2209 8.81722C7.38126 8.33614 7.75876 7.95863 8.23985 7.79827C8.72946 7.63507 8.72946 6.94253 8.23985 6.77933C7.75876 6.61897 7.38126 6.24146 7.2209 5.76038C7.0577 5.27077 6.36516 5.27077 6.20195 5.76038C6.04159 6.24146 5.66409 6.61897 5.18301 6.77933C4.69339 6.94253 4.69339 7.63507 5.18301 7.79827Z"
        fill="#219653"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 11.4672 19.9644 11.926 19.8958 12.374L15.8907 9.72526L15.889 9.72415C14.1738 8.58223 11.844 9.46989 11.3237 11.4641L11.3205 11.4769L10.9714 12.8913C9.65635 12.3809 8.13378 12.8586 7.3577 14.0791L4.82377 17.5463C3.08512 15.9054 2 13.5794 2 11ZM14.7843 11.3914L19.3352 14.4011C18.0267 17.6045 14.9252 19.8852 11.2779 19.9958L13.2603 11.9637C13.4366 11.3024 14.211 11.0092 14.7813 11.3894L14.7843 11.3914ZM10.4815 14.8759L9.25837 19.8316C8.2408 19.6321 7.28468 19.2611 6.42134 18.7499L9.01673 15.1986L9.03744 15.165C9.31953 14.7071 9.91322 14.5544 10.3813 14.8192L10.4815 14.8759Z"
        fill="#219653"
      />
    </svg>
  ),

  ic_values: (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.665 3.0001C10.665 3.0001 7.66498 -0.499903 3.66495 1.5001C1.08661 2.78926 0.282113 5.32204 0.766109 8.2019C1.55717 12.9088 7.40568 16.9888 9.72313 18.4379C10.3048 18.8016 11.0252 18.8016 11.6068 18.4379C13.9242 16.9888 19.7726 12.9088 20.5637 8.2019C21.0477 5.32204 20.2432 2.78926 17.6648 1.5001C13.6648 -0.499903 10.665 3.0001 10.665 3.0001Z"
        fill="#F2994A"
      />
    </svg>
  ),

  ic_mission: (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3359 0C11.8882 0 12.3359 0.447715 12.3359 1V3C12.3359 3.02071 12.3353 3.04127 12.3341 3.06166C15.9543 3.51223 18.8237 6.38165 19.2743 10.0019C19.2947 10.0006 19.3152 10 19.3359 10H21.3359C21.8882 10 22.3359 10.4477 22.3359 11C22.3359 11.5523 21.8882 12 21.3359 12H19.3359C19.3152 12 19.2947 11.9994 19.2743 11.9981C18.8237 15.6184 15.9543 18.4878 12.3341 18.9383C12.3353 18.9587 12.3359 18.9793 12.3359 19V21C12.3359 21.5523 11.8882 22 11.3359 22C10.7837 22 10.3359 21.5523 10.3359 21V19C10.3359 18.9793 10.3366 18.9587 10.3378 18.9383C6.71759 18.4878 3.84817 15.6184 3.3976 11.9981C3.3772 11.9994 3.35664 12 3.33594 12H1.33594C0.783653 12 0.335938 11.5523 0.335938 11C0.335938 10.4477 0.783653 10 1.33594 10H3.33594C3.35664 10 3.3772 10.0006 3.3976 10.0019C3.84817 6.38165 6.71758 3.51223 10.3378 3.06166C10.3366 3.04127 10.3359 3.02071 10.3359 3V1C10.3359 0.447715 10.7837 0 11.3359 0ZM11.3359 14C12.9928 14 14.3359 12.6569 14.3359 11C14.3359 9.34315 12.9928 8 11.3359 8C9.67908 8 8.33594 9.34315 8.33594 11C8.33594 12.6569 9.67908 14 11.3359 14Z"
        fill="#219653"
      />
    </svg>
  ),
};

export default Icons;
